import { useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { App } from "containers/App.jsx";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { colors } from "assets/colors/colors";
import { EVENTS } from "utils/analytics/Events.js";

const theme = (theme) =>
  createTheme({
    ...theme,
    breakpoints: {
      values: {
        xs: 0,
        sm: 768,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
    palette: {
      primary: {
        main: "#1e427b", // primary 80
        light: "#F3F6FC", // primary 10
        20: "#E6ECF9", // primary 20
      },
      core: {
        60: "#7C8698",
        70: "#98A1AE",
      },
      error: {
        main: "#B00020",
      },
    },
    shape: { borderRadius: 2 }, // sets general border radius used by many components
    components: {
      MuiPickersOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            borderColor: "#98a1ae",
          },
        },
      },
      MuiPickersTextField: {
        defaultProps: {
          fullWidth: true,
        },
      },
      MuiTextField: {
        defaultProps: {
          fullWidth: true,
        },
      },
      MuiSelect: {
        defaultProps: {
          fullWidth: true,
        },
      },
      MuiButton: {
        styleOverrides: {
          outlined: {
            minWidth: "140px",
          },
          contained: {
            minWidth: "140px",
          },
          root: {
            padding: "8px 16px",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          body: {
            minHeight: "48px",
            height: "48px",
            padding: "4px 16px",
            border: "none",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
          head: {
            padding: "12px 16px",
            borderBottomColor: colors.core30,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            "&.MuiTableRow-hover:hover": {
              backgroundColor: colors.primary20,
            },
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          root: {
            tableLayout: "fixed",
            width: "100%",
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            "&.MuiChip-filled": {
              color: colors.core100,
              background: colors.primary20,
            },
          },
        },
      },
      MuiAutocomplete: {
        defaultProps: {
          fullWidth: true,
        },
      },
    },
  });

export const RootContainer = ({ location }) => {
  useEffect(() => {
    import("utils/analytics/AnalyticsService.js").then(({ default: Analytics }) => {
      Analytics.track(EVENTS.Page_Open);
    });
  }, [location.pathname]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <App location={location} />
      </LocalizationProvider>
    </ThemeProvider>
  );
};
